import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Text, Box, List, Flex, Avatar } from "samba-ui";
import styled from "styled-components";

const ListLink = styled(Link)`
  text-decoration: none;
  display: block;
`;

const DashboardUsersList = ({ users }) => {
  return (
    <Box b={1} borderColor="#d6d6d6d">
      <List.Header borderColor="#d6d6d6 !important">
        <Text fontSize={1} color="secondary" fontWeight={500}>
          Remove this dashboard from following clients
        </Text>
      </List.Header>
      {users.map(user => {
        const { userId, imageURL, name, email } = user;
        return (
          <List.Item key={userId} borderColor="#d6d6d6 !important">
            <ListLink to={`/admin/users/${userId}`}>
              <Flex>
                <Avatar src={imageURL} mr={2} width={40} height={40} />
                <Box>
                  <Box>
                    <Text fontSize={1} color="palette.ink.normal">
                      {name}
                    </Text>
                  </Box>
                  <Text fontSize={1} color="palette.ink.normal">
                    {email}
                  </Text>
                </Box>
              </Flex>
            </ListLink>
          </List.Item>
        );
      })}
    </Box>
  );
};

DashboardUsersList.propTypes = {
  users: PropTypes.array.isRequired
};

export default DashboardUsersList;
